import {connect} from 'react-redux'
import * as action from '../state/action'
import * as selector from '../state/selector'
import PartialInvoiceCorrectionWidget from './PartialInvoiceCorrectionWidget';

const mapStateToProps = (state, props) => {
    return {
        taskName: props.taskName,
        salesOrderList: selector.selectSalesOrderPartialRefundList(state),
        partialRefundData: selector.selectPartialRefund(state),
        fetching: selector.selectFetching(state),
        validationMessageList: selector.selectValidationMessageList(state),
    };
};

const mapDispatchToProps = {
    getRefundableSalesOrderList: action.getRefundableSalesOrderList,
    getPartialRefundData: action.getPartialRefundData,
    changePartialRefundData: action.changePartialRefundData,
    savePartialRefundData: action.savePartialRefundData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartialInvoiceCorrectionWidget);



// WEBPACK FOOTER //
// ./src/modules/partial-refund/component/PartialInvoiceCorrectionWidgetContainer.js